<template>
  <div class="booksLiteratureList">
    <!-- 抬头 -->
    <div class="head">
      <div class="head-left">
        <h4>文献列表</h4>
      </div>
      <div class="head-right">
        <div class="head-right-input">
          <el-input
            :clearable="true"
            placeholder="请输入专家名称"
            v-model="managementInput"
            clearable
            @change="change"
          >
          </el-input>
          <el-button
            size="medium"
            style="background: #484c7f; color: #fff"
            @click="searchmanagemen"
          >搜索</el-button>
        </div>
        <div class="head-right-btn">
          <el-button
            size="medium"
            style="background: #258ce8; color: #fff"
            @click="uploadLiterature"
          >上传文献</el-button>
        </div>
      </div>
    </div>
    <!-- 抬头结束 -->
    <!-- tabs -->
    <div class="contents">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          label="待审核"
          name="0"
        >
          <div
            class="available"
            v-if="questionnairesObject.list.length==0"
          >
            <el-empty description="暂无数据"></el-empty>
          </div>
          <ul class="waiting">
            <li
              class="waiting-item"
              v-for="(item,index) in questionnairesObject.list"
              :key="index"
            >
              <div class="waiting-item-top">
                <div class="waiting-item-top-name">{{item.title}}</div>
                <div class="waiting-item-top-name-deng">
                  {{item.status_text}}
                </div>
                <div
                  @click="etcEditorClick(item)"
                  class="waiting-item-top-name-cha"
                  style="margin-right:40px;"
                >
                  <div class="waiting-item-top-name-cha-img">
                    <img src="../../assets/image/books/wenxianbianji.png">
                  </div>
                  <div style="color: #6e80a4; font-size: 13px;">编辑</div>
                </div>
                <div
                  class="waiting-item-top-name-cha"
                  @click="etcDeleteClick(item)"
                >
                  <div class="waiting-item-top-name-cha-img">
                    <img src="../../assets/image/books/wenxianshanchu.png">
                  </div>
                  <div style="color: #6e80a4; font-size: 13px;">删除</div>
                </div>
              </div>
              <div class="eyes">
                <div class="eyes-img">
                  <img src="../../assets/image/books/wenxianyan.png">
                </div>
                <div class="eyes-text">{{item.views}}</div>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane
          label="审核通过"
          name="1"
        >
          <div
            class="available"
            v-if="questionnairesObject.list.length==0"
          >
            <el-empty description="暂无数据"></el-empty>
          </div>
          <ul class="waiting">
            <li
              class="waiting-item"
              v-for="(item,index) in questionnairesObject.list"
              :key="index"
            >
              <div class="waiting-item-top">
                <div class="waiting-item-top-name">{{item.title}}</div>
                <div class="waiting-item-top-name-deng-tong">
                  {{item.status_text}}</div>
                <div
                  class="waiting-item-top-name-cha"
                  @click="viewClick(item)"
                >
                  <div class="waiting-item-top-name-cha-img">
                    <img src="../../assets/image/books/xieyicha.png">
                  </div>
                  <div style="color: #6e80a4; font-size: 13px;">查看</div>
                </div>
              </div>
              <div class="eyes">
                <div class="eyes-img">
                  <img src="../../assets/image/books/wenxianyan.png">
                </div>
                <div class="eyes-text">{{item.views}}</div>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane
          label="审核驳回"
          name="2"
        >
          <div
            class="available"
            v-if="questionnairesObject.list.length==0"
          >
            <el-empty description="暂无数据"></el-empty>
          </div>
          <ul class="waiting">
            <li
              class="waiting-item"
              v-for="(item,index) in questionnairesObject.list"
              :key="index"
            >
              <div class="waiting-item-top">
                <div class="waiting-item-top-name">{{item.title}}</div>
                <div class="waiting-item-top-name-deng-bo">{{item.status_text}}
                </div>
                <div
                   
                  @click="rejectionEditorClick(item)"
                  class="waiting-item-top-name-cha"
                  style="margin-right:40px;"
                >
                  <div class="waiting-item-top-name-cha-img">
                    <img src="../../assets/image/books/wenxianbianji.png">
                  </div>
                  <div style="color: #6e80a4; font-size: 13px;">编辑</div>
                </div>
                <div
                  class="waiting-item-top-name-cha"
                  @click="rejectionDeleteClick(item)"
                >
                  <div class="waiting-item-top-name-cha-img">
                    <img src="../../assets/image/books/wenxianshanchu.png">
                  </div>
                  <div style="color: #6e80a4; font-size: 13px;">删除</div>
                </div>
              </div>
              <div class="eyes">
                <div class="eyes-img">
                  <img src="../../assets/image/books/wenxianyan.png">
                </div>
                <div class="eyes-text">{{item.views}}</div>
              </div>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 上传协议 -->
    <div class="upload-protocol">
      <el-dialog
        title="上传文献"
        :visible.sync="protocolShow"
        width="30%"
      >
        <!-- 内容 -->
        <div class="upload-protocol-contents">
          <div>
            <div class="upload-protocol-contents-top">
              <div class="must">*</div>
              <div>文献标题</div>
            </div>
            <el-input
              style=" width: 80%;"
              v-model="uploadinput"
              placeholder="请输入文献标题"
            ></el-input>
          </div>

          <div
            style="display: flex;align-items: center; margin: 37px 0 12px 0;">
            <div class="must">*</div>
            <div>上传文献</div>
          </div>

          <div class="uploads-box">
            <el-upload
              class="upload-demo"
              :action="action"
              multiple
              :file-list="fileList"
              :on-success="accessorySuccess"
              :data="{file:'file',model:''}"
              ref="accessory"
              v-model="enclosure"
              :limit="1"
              :before-remove="beforeremove"
            >
              <el-button
                size="small"
                type="info"
              >选择文件</el-button>
              <div class="box"></div>
            </el-upload>
            <span class="ticks">允许上传PDF和照片类型文件</span>
          </div>
        </div>
        <!-- 内容 -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="protocolShow = false">取 消</el-button>
          <el-button
            type="primary"
            @click="uploadProtocolCreate"
          >确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 上传协议 -->
    <!-- 待审核 编辑协议 -->
    <div class="upload-protocol">
      <el-dialog
        title="编辑文献"
        :visible.sync="editorProjects"
        width="30%"
      >
        <!-- 内容 -->
        <div class="upload-protocol-contents">
          <div>
            <div class="upload-protocol-contents-top">
              <div class="must">*</div>
              <div>文献标题</div>
            </div>
            <el-input
              style=" width: 80%;"
              v-model="uploadinput"
              placeholder="请输入文献标题"
            ></el-input>
          </div>

          <div
            style="display: flex;align-items: center; margin: 37px 0 12px 0;">
            <div class="must">*</div>
            <div>上传文献</div>
          </div>

          <div class="uploads-box">
            <el-upload
              class="upload-demo"
              :action="action"
              multiple
              :file-list="fileList"
              :on-success="accessorySuccess"
              :data="{file:'file',model:''}"
              ref="accessory"
              v-model="enclosure"
              :limit="1"
              :before-remove="beforeremove"
            >
              <el-button
                size="small"
                type="info"
              >选择文件</el-button>
              <div class="box"></div>
            </el-upload>
            <span class="ticks">允许上传PDF和照片类型文件</span>
          </div>
        </div>
        <!-- 内容 -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="editorProjects = false">取 消</el-button>
          <el-button
            type="primary"
            @click="confirmationeDitorProjects"
          >确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 待审核 编辑协议 -->
    <!-- 驳回 编辑协议 -->
    <div class="upload-protocol">
      <el-dialog
        title="编辑文献"
        :visible.sync="RejectionProjects"
        width="30%"
      >
        <!-- 内容 -->
        <div class="upload-protocol-contents">
          <div>
            <div class="upload-protocol-contents-top">
              <div class="must">*</div>
              <div>文献标题</div>
            </div>
            <el-input
              style=" width: 80%;"
              v-model="uploadinput"
              placeholder="请输入文献标题"
            ></el-input>
          </div>
          <div
            style="display: flex;align-items: center; margin: 37px 0 12px 0;">
            <div class="must">*</div>
            <div>上传文献</div>
          </div>

          <div class="uploads-box">
            <el-upload
              class="upload-demo"
              :action="action"
              multiple
              :file-list="fileList"
              :on-success="accessorySuccess"
              :data="{file:'file',model:''}"
              ref="accessory"
              v-model="enclosure"
              :limit="1"
              :before-remove="beforeremove"
            >
              <el-button
                size="small"
                type="info"
              >选择文件</el-button>
              <div class="box"></div>
            </el-upload>
            <span class="ticks">允许上传PDF和照片类型文件</span>
          </div>
        </div>
        <!-- 内容 -->
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="RejectionProjects = false">取 消</el-button>
          <el-button
            type="primary"
            @click="RejectionDitorProjects"
          >确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 驳回 编辑协议 -->
    <div
      class="page"
      v-show="questionnairesObject.list!=0"
    >
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :page-count="questionnairesObject.pages"
        :current-page.sync="currentPage"
      >
      </el-pagination>
    </div>
  </div>
</template>  
  
<script>
export default {
  name: 'booksLiteratureList',
  data () {
    return {
      managementInput: '',//搜索
      statusIndx: '0',
      pagesize: 8,//每页显示条目个数 
      currentPage: 1,//当前页数   
      questionnairesObject: { list: [1] },
      activeName: '0',
      protocolShow: false,//上传协议弹窗
      editorProjects: false,//审核编辑文献弹窗
      RejectionProjects: false,//驳回编辑弹窗 
      uploadinput: '',//上传协议名称
      uploadID: '',//上传协议id
      action: `https://laravel.gongshicloud.com/api/index/upload`,//上传地址
      fileList: [],
      enclosure: '', //附件
    };
  },
  created () {
    this.getLiteratureList()
  },
  methods: {
    //抬头回车 
    change (value) {
      this.managementInput = value
      this.currentPage = 1
      setTimeout(() => {
        this.getLiteratureList()
      }, 500)
      this.$Spin.show();
    },
    //搜索按钮
    searchmanagemen () {
      this.currentPage = 1
      setTimeout(() => {
        this.getLiteratureList()
      }, 500)
      this.$Spin.show();
    },
    //切换  
    handleClick (tab, event) {
      this.statusIndx = tab.name
      setTimeout(() => {
        this.getLiteratureList()
      }, 500)
      this.$Spin.show();
    },
    //上传协议 打开
    uploadLiterature () {
      this.enclosure = ''
      this.uploadinput = ''
      this.fileList = []
      this.protocolShow = true
    },
    //附件
    accessorySuccess (res, file, fileList) {
      if (res.code != 200) {
        this.$message.error(res.message)
        this.$refs.accessory.clearFiles()
        return
      }
      this.$Loading.finish()
      this.enclosure = res.data.url
    },
    //删除附件 
    beforeremove (res, file, fileList) {
      this.enclosure = ''
      this.fileList = []
    },
    //上传协议 确定
    async uploadProtocolCreate () {
      const { data: data } = await this.$http.post('archives/expert-upload-literature', {
        id: this.$route.query.id,
        file_url: this.enclosure,
        title: this.uploadinput,
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.protocolShow = false
      this.getLiteratureList()
    },
    //文献列表 
    async getLiteratureList () {
      const { id, library_ent_id, library_expert_id, expert_name, ent_name } = this.$route.query
      const { data: data } = await this.$http.post('literature/expertList', {
        status: this.statusIndx,
        archive_id: id,//档案主键id  
        ent_id: library_ent_id,//项目id 
        expert_id: library_expert_id,//专家id
        title: this.managementInput,//文献标题  ent_name  
        limit: this.pagesize,//每页条数      
        page: this.currentPage,//第几页   
      })
      this.questionnairesObject = data.data
      this.$Spin.hide();
    },
    //待审核编辑
    etcEditorClick (item) {
      this.uploadinput = item.title
      this.uploadID = item.id
      this.enclosure = item.file_url
      this.fileList = [{ name: item.title, url: item.file_url }]
      this.editorProjects = true
    },
    //确认修改待审核编辑项目  
    async confirmationeDitorProjects () {
      const { data: data } = await this.$http.post('literature/editLiterature', {
        id: this.uploadID,
        title: this.uploadinput,
        file_url: this.enclosure
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.editorProjects = false
      this.getLiteratureList()
    },
    //待审核删除
    etcDeleteClick (item) {
      this.$confirm('确定要删除该文献吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('literature/deleteLiterature', { id: item.id })
        this.getLiteratureList()
        this.$message({
          message: data.message,
          type: 'success'
        });
      }).catch(() => { })
    },
    //驳回 编辑
    rejectionEditorClick (item) {
      this.uploadinput = item.title
      this.uploadID = item.id
      this.enclosure = item.file_url
      this.fileList = [{ name: item.title, url: item.file_url }]
      this.RejectionProjects = true
    },
    //确认修改驳回编辑项目   
    async RejectionDitorProjects () {
      const { data: data } = await this.$http.post('literature/editLiterature', {
        id: this.uploadID,
        title: this.uploadinput,
        file_url: this.enclosure
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.RejectionProjects = false
      this.getLiteratureList()
    },
    //驳回 删除
    rejectionDeleteClick (item) {
      this.$confirm('确定要删除该文献吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('literature/deleteLiterature', { id: item.id })
        this.getLiteratureList()
        this.$message({
          message: data.message,
          type: 'success'
        });
      }).catch(() => { })
    },
    //审核通过 查看
    async viewClick (item) {
      window.open(item.file_url)
    },
    //点击每一页   
    currentchange (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getLiteratureList()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getLiteratureList()
      }, 500)
      this.$Spin.show();
    },
    //下一页
    nextClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getLiteratureList()
      }, 500)
      this.$Spin.show();
    },
  }
}

</script>
<style lang="less" scoped>
.booksLiteratureList {
  background-color: #f9fbfd;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    .head-right {
      display: flex;
      .head-right-input {
        display: flex;
        align-items: center;
        /deep/.el-input {
          width: 332px;
          flex: 1;
          margin-right: 16px;
        }
      }
      .head-right-btn {
        margin-left: 190px;
      }
    }
    .head-left {
      h4 {
        font-size: 28px;
        color: #212529;
      }
    }
    .head-right {
      display: flex;
      .head-right-input {
        display: flex;
        align-items: center;
        /deep/.el-input {
          width: 332px;
          flex: 1;
          margin-right: 16px;
        }
      }
      .head-right-btn {
        margin-left: 190px;
      }
    }
  }

  /deep/ .el-tabs__nav-wrap::after {
    background-color: #fff;
  }
  .contents {
    width: 100%;
    min-height: 645px;
  }
  //待审核
  .waiting {
    .waiting-item {
      width: 100%;
      padding: 40px 0 16px 28px;
      background-color: #fff;
      margin-bottom: 18px;
      border-radius: 6px;
      .waiting-item-top {
        display: flex;
        margin-bottom: 22px;
        .waiting-item-top-name {
          width: 820px;
          margin-right: 80px;
        }

        .waiting-item-top-name-deng {
          color: #bbbbbb;
          position: relative;
          top: 5px;
          margin-right: 315px;
          font-size: 15px;
          &:after {
            content: "";
            width: 6px;
            height: 6px;
            background-color: #bbbbbb;
            border-radius: 50%;
            position: absolute;
            top: 7px;
            left: -10px;
          }
        }
        .waiting-item-top-name-deng-tong {
          color: #308811;
          position: relative;
          top: 5px;
          margin-right: 315px;
          font-size: 15px;
          &:after {
            content: "";
            width: 6px;
            height: 6px;
            background-color: #308811;
            border-radius: 50%;
            position: absolute;
            top: 7px;
            left: -10px;
          }
        }
        .waiting-item-top-name-deng-bo {
          color: #f11010;
          position: relative;
          top: 5px;
          margin-right: 315px;
          font-size: 15px;
          &:after {
            content: "";
            width: 6px;
            height: 6px;
            background-color: #f11010;
            border-radius: 50%;
            position: absolute;
            top: 7px;
            left: -10px;
          }
        }
        .waiting-item-top-name-cha {
          position: relative;
          top: 5px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .waiting-item-top-name-cha-img {
            width: 19px;
            height: 19px;
            margin-right: 8px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  //眼睛查看
  .eyes {
    display: flex;
    align-items: center;
    .eyes-img {
      width: 18px;
      height: 13px;
      margin-right: 10px;
      margin-top: -3px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .eyes-text {
      font-size: 13px;
      color: #b2b2b2;
    }
  }

  .must {
    font-size: 18px;
    color: #ff0d0d;
    margin-right: 6px;
  }

  .upload-protocol {
    //名称
    .upload-protocol-contents {
      .upload-protocol-contents-top {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
      }
    }
    //附件
    //新的
    .uploads-box {
      position: relative;
      .upload-demo {
        align-items: center;
        .el-button {
          border-radius: 6px 0 0 6px;
        }
        .box {
          position: absolute;
          top: 1px;
          left: 80px;
          // width: 421px;
          width: 65%;
          height: 32px;
          border: 1px solid #f0f0f0;
          border-radius: 0 6px 6px 0;
        }

        //文件位置
        /deep/ .el-upload-list__item {
          position: absolute !important;
          top: -6px !important;
          left: 80px !important;
          width: 64% !important;
        }
      }
      .ticks {
        position: absolute;
        color: #cc0808;
        font-size: 12px;
        margin-left: 3px;
        margin-top: 10px;
      }
    }
  }
  .page {
    margin-top: 30px;
    text-align: right;
  }

  .available {
    margin: 170px;
  }
}
</style>